module.exports = __webpack_public_path__ + "img/background063.3996cbbc.jpg";